"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = exports.getColorName = exports.getColorClass = void 0;
const getColorClass = (showColor, amount) => {
    if (showColor) {
        return Number(amount) > 0 ? ' income' : ' expense';
    }
    return '';
};
exports.getColorClass = getColorClass;
const getColorName = (showColor, amount) => {
    if (showColor) {
        return Number(amount) > 0 ? 'green' : 'red';
    }
    return 'black';
};
exports.getColorName = getColorName;
const getCurrencySymbol = ({ showCurrencySymbol, txn, getTxnCurrency }) => showCurrencySymbol && txn.accountId ? getTxnCurrency(txn.accountId) : 'N/A';
exports.getCurrencySymbol = getCurrencySymbol;
